import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { CustomersService } from 'app/_services/customer.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css'],
})
export class CustomersComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  customers: any[] = [];
  customerStoreUsers: any[] = [];
  selectedCustomer: any;

  storeId: any;

  filters: any;

  sidebarVisible = false;

  pageSizes: any = environment.pageSizes;
  pagination: any;

  selectedSort: any;

  sortFields: any[] = [
    {
      sortName: 'First Name (asc)',
      sortString: 'bludotUser.user.firstName,asc',
    },
    {
      sortName: 'First Name (desc)',
      sortString: 'bludotUser.user.firstName,desc',
    },
    {
      sortName: 'Last Name (asc)',
      sortString: 'bludotUser.user.firstName,asc',
    },
    {
      sortName: 'Last Name (desc)',
      sortString: 'bludotUser.user.firstName,desc',
    },
    {
      sortName: 'Organisation (asc)',
      sortString: 'bludotUser.user.firstName,asc',
    },
    {
      sortName: 'Organisation (desc)',
      sortString: 'bludotUser.user.firstName,desc',
    },
  ];

  filterFields: any[] = [
    {
      type: 'input',
      label: 'First Name',
      name: 'name',
      placeholder: 'Enter first name',
    },
    {
      type: 'input',
      label: 'Last Name',
      name: 'name',
      placeholder: 'Enter first name',
    },
    {
      label: 'Submit',
      name: 'submit',
      type: 'button',
    },
  ];

  role: any;
  routeRole: any;
  cookieStore: any;

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public _customerService: CustomersService,
    public cookieService: CookieService
  ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.routeRole + '/select-store']);
    }
    this.selectedSort = this.sortFields[0];
    this.resetPagination();
  }

  ngOnInit() {
    this.getAllCustomers();
  }

  public getAllCustomers() {
    // this._customerService.getAllCustomersByStore(this.storeId, this.pagination, this.selectedSort.sortString)
    //     .subscribe((data: any) => {
    //         // console.log(data);
    //         this.customers = data.body;
    //         this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    //     })

    this._customerService.getAllCustomersByStoreNoSort(this.storeId, this.pagination).subscribe((data: any) => {
      // console.log(data);
      this.customerStoreUsers = data.body;
      this.popCustomerArray(this.customerStoreUsers);
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public popCustomerArray(customerStoreArray) {
    customerStoreArray.forEach((element) => {
      // console.log(element);
      this._customerService.getCustomerById(element.bludotUserId).subscribe((data: any) => {
        this.customers.push(data);
      });
    });
  }

  // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
  onRowSelect(event) {
    this.router.navigate(['/' + this.globals.user.routeRole + '/customers/' + event.data.id]);
  }

  /* PAGINATION */
  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
  }

  paginate(event) {
    // console.log(event);
    this.customers = [];
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllCustomers();
  }
  /* PAGINATION END */

  // FILTER AND SORTING

  sortChange(event) {
    this.selectedSort = event;
    this.resetPagination();
  }

  filterFormSubmitted(value) {
    this.sidebarVisible = false;
    this.filters = value;
    this.resetPagination();
  }

  clearFilters() {
    this.sidebarVisible = false;
    this.filters = '';
    this.filterForm.clearForm();
    this.resetPagination();
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/customers.component.ts